import { Dialog } from "@mui/material";
import { Box, styled } from "@mui/system";
import { Button } from "@pav/pav-products-design-system";

export default function CancelModal({ open, handleClose, onSubmit }) {
  const StyledDialog = styled(Dialog)(() => ({
    "& .MuiDialog-container": {
      background: "rgba(122, 122, 122, 0.50)",
    },

    "& .MuiDialog-paper": {
      padding: "var(--spacing-2xl)",
      maxWidth: "337px",
      borderRadius: "16px",
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    },
  }));

  return (
    <StyledDialog open={open}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--spacing-2xl)",
        }}
      >
        <Box className="header" sx={{ textAlign: "left" }}>
          Are you sure you want to cancel?
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "var(--spacing-md)",
          }}
        >
          <Button buttonType="primary" fullWidth onClick={handleClose}>
            NO
          </Button>
          <Button buttonType="secondary" fullWidth onClick={onSubmit}>
            YES
          </Button>
        </Box>
      </Box>
    </StyledDialog>
  );
}
